export { default } from './BarchartWidgetBar';
